/**
 * Normalize a phone number to a bare digit suffix for matching.
 * Strips separators, then a leading 0049/+49 country prefix, then a
 * leading national 0. Mirrors the index-time normalization the backend
 * will eventually apply (spec §6).
 *
 * NOTE: not yet wired into the live search path — phone matching currently rides on the ES
 * `simple_query_string` over `*`. Kept ready for the real gateway / BE sub-ticket (US-4), which
 * will normalize both the query and an indexed normalized-number field with this same logic.
 */
export function normalizePhone(raw: string): string {
  const startedWithPlus = raw.trim().startsWith('+');
  let d = raw.replace(/\D/g, '');
  if (d.startsWith('0049')) d = d.slice(4);
  else if (startedWithPlus && d.startsWith('49')) d = d.slice(2);
  if (d.startsWith('0')) d = d.replace(/^0+/, '');
  return d;
}
